<template>
    <div>
    
        <v-row>            
            <v-col class="text-center"  cols="12" v-if="presentacion.titulo">
                  <v-card outlined class="mt-1 py-3" :style="[{'background-color':color_fondo_titulo}]"> 
                      <span class="ma-2 gestor_titulo" v-html="presentacion.titulo"></span>
                  </v-card>
            </v-col>

            <v-col class="text-center" cols="12" v-if="presentacion.subtitulo">
                <v-card outlined class="mt-1 py-3" :style="[{'background-color':color_fondo_subtitulo}]"> 
                    <span class="ma-2 gestor_subtitulo" v-html="presentacion.subtitulo"></span>
                </v-card>
            </v-col>

            <!-- START Contenido Diapositiva COL 1 -->  

            <v-col cols="6" :style="[{'background-color':color_fondo_col01 , 'min-height':'70vh'}]" >

                <v-row v-for="(item) of presentacion.seccion1" :key="item.id" class="ma-4 pa-2">

                    <template v-if="item.nombre!=''"> 
                        <v-col cols> 
                            <div class="ma-2 gestor_texto" v-html="item.nombre"></div>
                        </v-col>
                    </template> 

                   <template v-if="item.img_path!='' && item.img_path !=undefined" >
                        <v-row justify="center" style="cursor:pointer">
                            <v-img contain aspect-ratio="1"  max-width="500" max-height="400"
                                :src="rutaServe+item.img_path+timestamp" @click="verImage(rutaServe+item.img_path+timestamp)">
                            </v-img>
                        </v-row>
                    </template>  
                    
                    <template v-if="item.vid_path!='' && item.vid_path !=undefined && screen==false">                        
                        <v-row  class="d-flex justify-center">
                            <video width="450px" height="300px" preload="metadata"  loop  controls>
                                <source :src="rutaServe+item.vid_path" type="video/mp4" />
                                <source :src="rutaServe+item.vid_path" type="video/ogg" />
                                <source :src="rutaServe+item.vid_path" type="video/webm" />
                            </video>
                        </v-row>
                    </template>
                    
                    <template v-if="item.vid_path!='' && item.vid_path !=undefined && screen==true">
                        <v-row justify="center" >
                            <v-img contain aspect-ratio="1" max-width="500" max-height="400"
                                src='@/assets/mediaVideo.jpg'>
                            </v-img>
                        </v-row>
                    </template>

                    <div v-if="item.name_file===null || item.name_file===undefined || item.name_file===''">
                    </div>
                    <div v-else class="mb-3 seccion-pdf">
                        <v-icon color="error" class="ml-2 mr-2">fas fa-file-pdf</v-icon> 
                        <a :href="rutaServe+item.file_path" target="_blank">{{item.name_file}}</a>
                    </div>
                </v-row>
            </v-col>                
           
              <!-- END Contenido Diapositiva COL 1 -->
              <!-- START Contenido Diapositiva COL 2 --> 
            
            <v-col cols="6"  :style="[{'background-color':color_fondo_col02, 'min-height':'70vh'}]">
         
                <v-row  v-for="(item) of presentacion.seccion2" :key="item.id" class="ma-0 pa-2">
                    
                    <template v-if="item.nombre2!=''">  
                        <v-col cols>
                            <div class="ma-2 gestor_texto" v-html="item.nombre2"></div>
                        </v-col>
                    </template> 

                    <template v-if="item.img_path2!='' && item.img_path2 !=undefined">
                        <v-row  justify="center" style="cursor:pointer">
                            <v-img contain aspect-ratio="1"  max-width="500" max-height="400"
                                :src="rutaServe+item.img_path2+timestamp" @click="verImage(rutaServe+item.img_path2+timestamp)">
                            </v-img>
                        </v-row>
                    </template>
                    
                    
                    <template v-if="item.vid_path2!='' && item.vid_path2 !=undefined && screen==false">                        

                        <v-row class="d-flex justify-center">
                            <video width="450px" height="300px" preload="metadata"  loop  controls>
                                <source :src="rutaServe+item.vid_path2" type="video/mp4" />
                                <source :src="rutaServe+item.vid_path2" type="video/ogg" />
                                <source :src="rutaServe+item.vid_path2" type="video/webm" />
                            </video>
                        </v-row>
                    </template>

                    <template v-if="item.vid_path2!='' && item.vid_path2 !=undefined && screen==true">                        
                        <v-row justify="center" >
                            <v-img contain aspect-ratio="1" max-width="500" max-height="400"
                                src='@/assets/mediaVideo.jpg'>
                            </v-img>
                        </v-row>
                    </template>

                    <div v-if="item.name_file2===null || item.name_file2===undefined || item.name_file2===''">
                    </div>
                    <div v-else class="mb-3 seccion-pdf">
                        <v-icon color="error" class="ml-2 mr-2">fas fa-file-pdf</v-icon> <a :href="rutaServe+item.file_path2" target="_blank">{{item.name_file2}}</a>
                    </div>
                </v-row>
            </v-col>           
                   
    
            <!-- END Contenido Diapositiva COL 2 -->

        
             
            
        </v-row>
        <!-- Contenido Diapositiva end -->
        
        <!-- modal  --> 
        <v-dialog v-model="visualizar_imagen" scrollable max-width="50%">
            <v-card>
                <v-card-title class="btn_otro">
                    <v-row class="d-flex justify-end py-0">                
                        <v-btn fab dark x-small class="btn_style3" @click="visualizar_imagen=false"><v-icon dark>fa-times</v-icon></v-btn>
                    </v-row>
                </v-card-title>

                <v-divider></v-divider>
            
                <v-card-text class="mt-2"> 
                    <v-img contain  style="height:auto;" :src="setImagen"></v-img>                      
                </v-card-text>
            </v-card>
        </v-dialog>


    </div>
</template>

<script>
import '@/assets/css/gestor_contenido.css';
    import {API_URL} from "@/helpers/axios";

export default {
    name: 'vistacol02',
    props:['presentacion', 'screen'],
    data() {
        return {
            rutaServe: API_URL,
            //  msj:false,  text:'', tipo:'',
            visualizar_imagen:false,
            setImagen:'',
            timestamp : `/${new Date().getTime()}`
        };

    },


    computed: {
      
        background() {
            let color = this.presentacion.background 
            return color === '' || color == null  ? "#FFFFFF" : color 
        },

        color_fondo_titulo () {
            let color = this.presentacion.color_fondo_titulo 
            return color === '' || color == null  ? "#FFFFFF" : color 
        },

        color_fondo_subtitulo () {
            let color = this.presentacion.color_fondo_subtitulo 
            return color === '' || color == null  ? "#FFFFFF" : color 
        },

        color_fondo_col01 () {
            let color = this.presentacion.color_fondo_col01 
            return color === '' || color == null  ? "#7BBDE6" : color 
        },

        color_fondo_col02 () {                
            let color = this.presentacion.color_fondo_col02
            return color === '' || color == null  ? "#E4F5FF" : color 
        },

        color_fondo_col03 () {                
            let color = this.presentacion.color_fondo_col03
            return color === '' || color == null  ? "#7BBDE6" : color 
        },
    },  

    methods: {

        verImage(image){
            this.setImagen = image
            this.visualizar_imagen = true
        },

    },


}
</script>

<style scoped>

.seccion-pdf{
    width: 100%;
    background: #ffffff;
    width: 100%;
    height: 60px;
    margin-top: 13px;
    padding-top: 15px;
    border: 2px dotted #1DABE0;
}
</style>


